import { lazy } from 'react';
import { MonolithCartStripeContainer } from './MonolithCartStripeContainer';

type MonolithCartStripeContainerType = typeof MonolithCartStripeContainer;

/**
 * Lazy load the StripeContainer to prevent unnecessary Stripe SDK initialisation.
 *
 * The Stripe SDK (@stripe/stripe-js) has top-level initialisation code that
 * executes immediately when the Stripe modules are imported, making network
 * calls for JavaScript files and analytics tracking.
 *
 * Without lazy loading, the Stripe SDK would initialize on every PDP load
 * when this component is imported, impacting performance.
 */
export const MonolithCartStripeContainerLazy =
  lazy<MonolithCartStripeContainerType>(
    () => import('@app/components/Stripe/MonolithCartStripeContainer')
  );
